import KeywordDetailContent from '@/components/dashboard/pages/keyword-researcher-v2/keyword-detail-drawer-content';
import {useStore} from '@/store/root-store';
import {CloseOutlined} from '@ant-design/icons';
import {Drawer} from 'antd';
import {observer} from 'mobx-react-lite';

export const KeywordsDrawer = observer(() => {
  const {contentOptimizer: {currentPage}} = useStore('');

  return <Drawer
    visible={currentPage.isOpenKeywordsDrawer}
    placement='right'
    width={'80vw'}
    afterVisibleChange={visible => {
      // scroll to related keywords table automaticaly
      if (visible) {
        if (currentPage?.isDrawerFromCa) {
          document.getElementById('SuggestedKeywordTableId')?.scrollIntoView({block: 'center'});
        }
      }
    }}
    onClose={() => {
      currentPage.setIsDrawerFromCa(false);
      currentPage.setIsOpenKeywordDrawer(false);
      currentPage.setActiveTargetKw('');
    }}
    bodyStyle={{backgroundColor: '#F2F2F5', paddingLeft: '0', paddingRight: '0'}}
    className={'drawerCloseIcon'}
    closeIcon={<CloseOutlined className={'closeIcon'} style={currentPage.isOpenKeywordsDrawer ? {display: 'block'} : {display: 'none'}}/>}>
    <KeywordDetailContent />
  </Drawer>;
});
